import React, { useEffect, useState } from "react";
import {
  McModal,
  McButton,
} from "@maersk-global/mds-react-wrapper/components-core";
import { Typography } from "@anchor/react-components/dist/lib/components";

function RecommendedActionsModal({ data, modalOpen, handleModal }) {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <McModal
        backdropcloseactiondisabled={true}
        // heading="Heading"
        open={modalOpen}
        // closed={() => handleModal()} //If needed, the event.detail gives you the action name which has closed the modal, for more details please look at the docs in the controls tab
        // closing={() => handleModal()} //If needed, the event.detail gives you the action name which is closing the modal, for more details please look at the docs in the controls tab
        width={screenWidth >= 1600 ? "1600px" : `${screenWidth - 200}px`}
        height="400px"
        hiddenclose={true}
      >
        <div style={{ display: "flex", padding: "20px" }}>
          <div
            style={{
              width: "100%",
            }}
            className="recommended-actions-container"
          >
            <Typography variant="h4">Recommended Actions</Typography>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
                gap: "15px",
                marginBottom: "20px",
              }}
            >
              {data && data.length > 0 ? (
                data.map((action, index) => (
                  <div
                    key={index}
                    style={{
                      backgroundColor: "#B5E0F5",
                      padding: "15px",
                      borderRadius: "10px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        wordBreak: "break-word",
                      }}
                    >
                      {action.description}
                    </div>
                  </div>
                ))
              ) : (
                <div
                  style={{
                    backgroundColor: "#B5E0F5",
                    padding: "15px",
                    borderRadius: "10px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  <div
                    style={{
                      fontSize: "14px",
                      wordBreak: "break-word",
                    }}
                  >
                    No recommended actions available.
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <McButton
          focusstartanchor
          slot="primaryAction"
          appearance="primary"
          dialogaction="ok"
          onClick={() => handleModal()}
        >
          OK
        </McButton>
      </McModal>
    </>
  );
}

export default RecommendedActionsModal;
